import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteBillRate } from 'api/billRates/deleteBillRate'
import { billRatesKey } from './keys'

export const useDeleteBillRateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: Parameters<typeof deleteBillRate>[0]) =>
      deleteBillRate(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: billRatesKey })
    },
  })
}
